import styles from "./Contact.module.css";
import { MapPin, Phone, Mail } from "lucide-react";
import MapWithConsent from "../components/MapWithConsent";

export default function Contact() {
  return (
    <main className={styles.contactPage}>
      <section className={styles.infoSection}>
        <h1>Kontaktieren Sie uns</h1>

        <div className={styles.list}>
          <div className={styles.row}>
            <MapPin className={styles.icon} />
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Grunewaldstra%C3%9Fe+24,+12165+Berlin"
              target="_blank"
              rel="noopener noreferrer"
            >
              Grunewaldstraße 24
              <br />
              12165 Berlin
            </a>
          </div>

          <div className={styles.row}>
            <Phone className={styles.icon} />
            <a href="tel:+49308145294">+49 (0)30 814 52 94</a>
          </div>

          <div className={styles.row}>
            <Mail className={styles.icon} />
            <a href="mailto:info@fernando-international.com">
              info@fernando-international.com
            </a>
          </div>
        </div>
      </section>

      <section className={styles.mapWrapper}>
        <MapWithConsent />
      </section>
    </main>
  );
}
